import { useContext } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

import { AuthContext } from "../context/AuthContext";
import ToastMsg from "../components/common/ToastMsg";

const useApiWrapper = () => {
  const navigate = useNavigate();
  const { logoutauth } = useContext(AuthContext);

  const apiWrapper = async (apiCall, setLoading) => {
    try {
      if (setLoading) setLoading(true);

      const response = await apiCall();

      // Only handle critical auth cases here
      if (response?.detail === "You are not authorized to perform this action") {
        logoutauth();
        navigate("/");
        return { status: "fail", message: response.detail };
      }

      if (
        response?.detail ===
        "You are attempting to log in without an active subscription. Please subscribe to a plan to access the system."
      ) {
        ToastMsg("error", response.detail);
        navigate("/myplans");
        return { status: "fail", message: response.detail };
      }

      // Otherwise, return the actual response
      return response;
    } catch (error) {
      // Aborted requests (AbortController) are an expected control-flow signal
      // from the caller — surface a quiet "cancelled" result instead of a toast.
      if (axios.isCancel?.(error) || error?.name === "CanceledError" || error?.name === "AbortError") {
        return { status: "cancelled" };
      }
      if (error.response) {
        const msg =
          error.response.data?.message ||
          error.response.data?.detail ||
          "An error occurred.";
        // ToastMsg("error", msg); // optional: show error toast here

        if (error.response.status === 401) {
          logoutauth();
          navigate("/");
        }

        return { status: "fail", message: msg };
      } else if (error.request) {
        // ToastMsg("error", "Network error. Please check your connection.");
        return { status: "fail", message: "Network error" };
      } else {
        ToastMsg("error", error.message || "Unexpected error occurred.");
        return { status: "fail", message: error.message };
      }
    } finally {
      if (setLoading) setLoading(false);
    }
  };

  return { apiWrapper };
};

export default useApiWrapper;
